import { Field as ChakraField, Fieldset, HStack, Input, VStack } from '@chakra-ui/react';
import { CockpitFormLayout } from '@components/cockpit/layouts/CockpitFormLayout';
import ModifiedTag from '@components/common/form/ModifiedField';
import { Field, FormikProps, FormikProvider } from 'formik';
import { FormattedMessage } from 'react-intl';

import { Pilot } from '@/types/utm/pilot.types';

type Props = {
  formik: FormikProps<Partial<Pilot>>;
};

export default function PilotGeneralTab({ formik }: Readonly<Props>) {
  return (
    <CockpitFormLayout title="components.utm.pilots.tab.general.title">
      <FormikProvider value={formik}>
        <Fieldset.Root
          invalid={Object.keys(formik.errors).some((key) => formik.touched[key as keyof typeof formik.touched])}
        >
          <VStack width="100%" gap={5} alignItems="start">
            <HStack width="100%" gap={2}>
              <ChakraField.Root
                variant="cockpit"
                required
                invalid={formik.touched.firstName && !!formik.errors.firstName}
              >
                <ChakraField.Label width="100%" height="20px">
                  <FormattedMessage id="components.utm.pilots.tab.general.firstName" />
                  <ChakraField.RequiredIndicator />
                  {formik.initialValues.firstName !== formik.values.firstName && <ModifiedTag />}
                </ChakraField.Label>
                <Field as={Input} type="text" name="firstName" id="firstName" />
              </ChakraField.Root>
              <ChakraField.Root
                variant="cockpit"
                required
                invalid={formik.touched.lastName && !!formik.errors.lastName}
              >
                <ChakraField.Label width="100%" height="20px">
                  <FormattedMessage id="components.utm.pilots.tab.general.lastName" />
                  <ChakraField.RequiredIndicator />
                  {formik.initialValues.lastName !== formik.values.lastName && <ModifiedTag />}
                </ChakraField.Label>
                <Field as={Input} type="text" name="lastName" id="lastName" />
              </ChakraField.Root>
            </HStack>
            <ChakraField.Root
              variant="cockpit"
              required
              invalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
            >
              <ChakraField.Label width="100%" height="20px">
                <FormattedMessage id="components.utm.pilots.contact" />
                <ChakraField.RequiredIndicator />
                {formik.initialValues.phoneNumber !== formik.values.phoneNumber && <ModifiedTag />}
              </ChakraField.Label>
              <Field as={Input} type="text" name="phoneNumber" id="phoneNumber" />
            </ChakraField.Root>
            <ChakraField.Root variant="cockpit" required invalid={formik.touched.email && !!formik.errors.email}>
              <ChakraField.Label width="100%" height="20px">
                <FormattedMessage id="components.utm.pilots.tab.general.email" />
                <ChakraField.RequiredIndicator />
                {formik.initialValues.email !== formik.values.email && <ModifiedTag />}
              </ChakraField.Label>
              <Field as={Input} type="text" name="email" id="email" />
            </ChakraField.Root>
          </VStack>
        </Fieldset.Root>
      </FormikProvider>
    </CockpitFormLayout>
  );
}
